// Helper simples de API para os módulos Oplena (clientes, boletos, help desk).
import config from "../../../config";

const BASE = config.api.API_URL; // ex.: http://localhost:48000

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("users") || "{}")?.token || "";
  } catch {
    return "";
  }
};

const req = async (method, path, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  let json = null;
  try {
    json = await res.json();
  } catch {}
  if (!res.ok) throw new Error(json?.message || `Erro ${res.status}`);
  return json?.data;
};

const api = {
  get: (p) => req("GET", p),
  post: (p, b) => req("POST", p, b),
  put: (p, b) => req("PUT", p, b),
  del: (p) => req("DELETE", p),
};

export default api;
